export default "__VITE_ASSET__CLCuIaa4__"